module.exports = __webpack_public_path__ + "static/media/usa-icon.a5a23005.svg";